import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { FiCreditCard } from "react-icons/fi";
import CrudEditPage from "../../../components/crud/CrudEditPage";
import { accounts } from "../../utils/accountConstants";

const favoriteGroups = [
	{ group: "NL", groups: ["NL Credit", "NL Accounts", "Immerge", "Investing", "Retirement"] },
	{ group: "Erin", groups: ["Erin Accounts", "Retirement"] },
];

const AddAccountBalances = () => {
	const [accountValues, setAccountValues] = useState({});
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();
	const { group } = useParams();

	const matchedFavorite = favoriteGroups.find((fav) => fav.group === group);

	// Filter accounts belonging to allowed subgroups
	const favoriteAccounts = matchedFavorite
		? accounts.filter((acc) => matchedFavorite.groups.includes(acc.group))
		: [];

	// Organize accounts into a map: { subgroup -> accounts[] }
	const accountsBySubgroup = {};
	favoriteAccounts.forEach((acc) => {
		if (!accountsBySubgroup[acc.group]) {
			accountsBySubgroup[acc.group] = [];
		}
		accountsBySubgroup[acc.group].push(acc);
	});

	const handleChange = (accountName, value) => {
		setAccountValues((prev) => ({
			...prev,
			[accountName]: value,
		}));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);

		const submissionData = Object.entries(accountValues)
			.filter(([_, value]) => value !== "" && Number(value) !== 0)
			.map(([account, value]) => ({
				account,
				value,
				date_edited: new Date().toISOString().slice(0, 10),
			}));

		if (submissionData.length === 0) {
			setLoading(false);
			return;
		}

		try {
			await axios.post(`${process.env.REACT_APP_BACKEND_URL}/money/multipleAccountBalances`, submissionData);
			navigate("/accountBalance");
		} catch (err) {
			console.log(err);
		} finally {
			setLoading(false);
		}
	};

	return (
		<CrudEditPage
			title={`Add Balances - ${group}`}
			backLink="/accountBalance"
			backLabel="Back to Balances"
			breadcrumb={[
				{ label: "Money", to: "/lavella-dashboard" },
				{ label: "Account Balances", to: "/accountBalance" },
				{ label: `Add ${group}` },
			]}
			onSubmit={handleSubmit}
			submitLabel="Add All Balances"
			isLoading={loading}
			variant="v4"
			icon={<FiCreditCard />}
		>
			<div className="bulk-add-grid">
				{Object.keys(accountsBySubgroup).length > 0 ? (
					Object.entries(accountsBySubgroup).map(([subgroup, groupAccounts]) => (
						<div key={subgroup} className="bulk-add-card">
							<h4 className="bulk-add-card__title">{subgroup}</h4>
							<div className="bulk-add-card__fields">
								{groupAccounts.map((account) => (
									<div className="bulk-add-field" key={account.account}>
										<label className="bulk-add-field__label">
											{account.name || account.account}
										</label>
										<input
											type="number"
											className="bulk-add-field__input"
											placeholder="$0.00"
											value={accountValues[account.account] || ""}
											onChange={(e) => handleChange(account.account, e.target.value)}
											step="0.01"
										/>
									</div>
								))}
							</div>
						</div>
					))
				) : (
					<p className="bulk-add-empty">No accounts found for this group.</p>
				)}
			</div>
		</CrudEditPage>
	);
};

export default AddAccountBalances;
